<div class="modal-header">
    <h2 class="modal-title font-weight-bold" id="displayName" *ngIf="patient">
        {{ "PATIENT.EDIT.TITLE-UPDATE" | translate }}
        <br/>
        <h4>{{patient?.lname}} {{patient?.fname}}</h4>
    </h2>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">

    <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>

    <form *ngIf="patientForm" [formGroup]="patientForm" novalidate (ngSubmit)="editPatient(patientForm.value)">
        <div class='form-row mb-3 border-bottom  my-row'>
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.LNAME' | translate }}" formControlName="lname" id="lname">
                    <mat-error *ngIf="hasError('lname','required')">{{ "ERRORS.LNAME-REQUIRED" | translate }}</mat-error>
                    <mat-error *ngIf="hasError('lname', 'pattern')">{{
                      "ERRORS.LNAME-INVALID" | translate
                    }}</mat-error>
                </mat-form-field>
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.FNAME' | translate }}" formControlName="fname" id="fname">
                    <mat-error *ngIf="hasError('fname','required')">{{ "ERRORS.FNAME-REQUIRED" | translate }}</mat-error>
                    <mat-error *ngIf="hasError('fname', 'pattern')">{{
                      "ERRORS.FNAME-INVALID" | translate
                    }}</mat-error></mat-form-field>
                <mat-form-field class="mx-2">
                    <mat-label>{{ "FORM.BIRTHDATE" | translate }}</mat-label>
                    <input matInput readonly formControlName="dateOfBirth" (focus)="picker.open()" id="dateOfBirth" [max]="maxDate" [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <mat-form-field class="mx-2">
                    <input matInput *ngIf="!patient" type="text" placeholder="{{ 'FORM.MAIL' | translate }}" formControlName="email" id="email">
                    <input matInput *ngIf="patient" readonly type="text" placeholder="{{ 'FORM.MAIL' | translate }}" formControlName="email" id="email">
                    <mat-error *ngIf="hasError('email','required')">{{ "ERRORS.MAIL-REQUIRED" | translate }}</mat-error>
                    <mat-error *ngIf="hasError('email', 'email')">{{ "ERRORS.MAIL-INVALID" | translate }}</mat-error>
                    <mat-error *ngIf="hasError('email', 'pattern')">{{ "ERRORS.MAIL-INVALID" | translate }}</mat-error>
                </mat-form-field>
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.CITY' | translate }}" formControlName="city"
                    [matAutocomplete]="auto" (blur)="checkCity()">
                    <mat-error *ngIf="hasError('city', 'pattern')">{{
                      "ERRORS.CITY-INVALID" | translate
                    }}</mat-error>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="cityClick($event)">
                        <mat-option *ngFor="let city of filteredOptions | async" [value]="city.nom">
                            {{city.nom}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class='col-6 col-lg-auto pb-3 my-col'>
                <mat-form-field *ngIf="patientForm.get('ins')" class="mx-2">
                  <input matInput type="text" *ngIf="!patient" placeholder="{{ 'FORM.INS' | translate }}" formControlName="ins" id="ins">
                  <input matInput type="text" *ngIf="patient" readonly placeholder="{{ 'FORM.INS' | translate }}" formControlName="ins" id="ins">
                </mat-form-field>
                <mat-form-field class="mx-2">
                    <input matInput type="text" placeholder="{{ 'FORM.PHONE' | translate }}" formControlName="phoneNumber" id="phoneNumber">
                    <mat-error *ngIf="hasError('phoneNumber','forbidden')">{{ "ERRORS.PHONE-INVALID" | translate }}</mat-error>
                    <mat-error *ngIf="hasError('phoneNumber','required')">{{ "ERRORS.PHONE-REQUIRED" | translate }}</mat-error>
                </mat-form-field>
            </div>
            <div class='col-6 col-lg-auto pb-3 my-col mx-2'>
                <div class="form-check form-switch">
                    <input class="form-check-input" *ngIf="!patient" type="checkbox" id="consent" formControlName="consent">
                    <input class="form-check-input" *ngIf="patient" type="checkbox" id="consent" formControlName="consent" [attr.disabled]="true">
                    <label class="form-check-label" for="consent">{{ "FORM.CONSENT" | translate }}</label>
                    <mat-error *ngIf="hasError('consent','forbidden')">{{ "ERRORS.CONSENT-REQUIRED" | translate }}</mat-error>
                </div>
                <div id="consentDate" *ngIf="this.patient">
                    <p>{{ "FORM.CONSENT-DATE" | translate }} {{this.patient?.consentDate}}</p>
                </div>
            </div>

            <div class='col-6 col-lg-auto pb-3 my-col'>
                <p [innerHTML]="'FORM.REQUIRED-DATA' | translate" style="color:#f44336"></p>
            </div>
        </div>

        <div class='form-row pt-3 my-row'>
            <div class='col my-col'>
                <button type="submit" class="btn btn-primary mx-1" *ngIf="patient" [disabled]="!patientForm.valid">{{ "BUTTONS.UPDATE" | translate }}</button>
                <button type="button" class="btn btn-danger" (click)="activeModal.close('')">{{ "BUTTONS.CLOSE" | translate }}</button>
            </div>
        </div>
    </form>
</div>
